import { apiSlice } from '../../store/apiSlice';

export const extendedApiSlice = apiSlice
  .enhanceEndpoints({ addTagTypes: ['Brands'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getBrands: builder.query({
        query: ({ tiers } = { tiers: ['tier1', 'tier2'] }) => ({
          url: `marketing/brands?tier=${tiers.toString()}`,
          method: 'get',
        }),
      }),
      updateBrandEngagement: builder.mutation({
        query: (data) => ({
          method: 'put',
          useDefaultErrorHandler: false,
          url: `marketing/brands/update-engagement`,
          params: data,
        }),
      }),
    }),
  });

export const { useGetBrandsQuery, useUpdateBrandEngagementMutation } =
  extendedApiSlice;
